/**
 * Filter extra-warning messages for Overlay Data fields and/or widgets.
 *
 * Use as a mixin.
 *
 * Depends on:
 *   - this.extraWarnings (Array[Object]): A prop.
 */

export default {
  methods: {
    getExtraWarningForField(field) {
      if (!this.extraWarnings) {
        return null;
      }
      for (const warning of this.extraWarnings) {
        if (warning.fieldName === field.name) {
          return warning;
        }
      }
      return null;
    },
    getExtraWarningsForWidget(widget) {
      if (!this.extraWarnings) {
        return null;
      }
      if (!widget.field_mapping) {
        return null;
      }
      const widgetExtraWarnings = [];
      const widgetFieldNames = Object.values(widget.field_mapping)
        .filter((field) => !!field)
        .map((field) => field.name);
      for (const warning of this.extraWarnings) {
        if (widgetFieldNames.includes(warning.fieldName)) {
          widgetExtraWarnings.push(warning);
        }
      }
      return widgetExtraWarnings;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/overlayDataExtraWarnings.js